function initMap() {
    var locations = [
        { lat: 52.6369, lng: -1.1398, name: "Leicester - Store A" },
        { lat: 51.5074, lng: -0.1278, name: "London - Store B" }
        // Add more store locations here...
    ];

    var map = new google.maps.Map(document.getElementById("map"), {
        zoom: 6,
        center: locations[0]
    });

    locations.forEach(function(location) {
        new google.maps.Marker({
            position: location,
            map: map,
            title: location.name
        });
    });
}

// Load Google Maps API dynamically with async & defer
document.addEventListener("DOMContentLoaded", function () {
    var script = document.createElement("script");
    script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyCFLSQMhoKwVhZpc1FLrMMS8MyByi3cg4k&callback=initMap";
    script.async = true;   // ✅ Prevents blocking
    script.defer = true;   // ✅ Ensures it loads after the page
    document.body.appendChild(script);
});
